export const useFormValidation = () => {
  const isValidEmail = (email: string): boolean => {
    if (!email) return false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isAdult = (birthDate: string): boolean => {
    if (!birthDate) return false;
    const birth = new Date(birthDate);
    const today = new Date();
    const age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
      return age - 1 >= 18;
    }
    return age >= 18;
  };

  const isValidPhone = (phone: string): boolean => {
    if (!phone) return false;
    // Remover espacios, guiones y paréntesis
    let cleaned = phone.replace(/\s+/g, '').replace(/-/g, '').replace(/\(/g, '').replace(/\)/g, '');
    
    // Si tiene +52 al inicio, removerlo para validar solo los 10 dígitos
    if (cleaned.startsWith('+52')) {
      cleaned = cleaned.substring(3);
    }
    
    // Validar que tenga exactamente 10 dígitos y que no empiece con 0
    const phoneRegex = /^[1-9]\d{9}$/;
    return phoneRegex.test(cleaned);
  };

  const isValidPostalCode = (postalCode: string): boolean => {
    // Si hay un código postal guardado (viene del combo), es válido automáticamente
    // No validamos formato porque viene de un combo válido
    return !!postalCode && postalCode.length > 0;
  };

  return {
    isValidEmail,
    isAdult,
    isValidPhone,
    isValidPostalCode,
  };
};

